<script>
export default {
    name: "copyright",
    data() {
        return {
            history: window.history.length,
        };
    },
    computed: {},
    components: {
        
    },
    mounted() {},
    destroyed() {},
    watch: {},
    methods: {},
};
</script>

<template>
    <div class="copyright">
        <div class="banner flex align_center justify_center">
            <div class="layout_bg bg" :style="`background-image: url(${require('@/assets/images/copyright.jpg')});`"></div>
            <p class="name text_shadow">版权信息</p>
        </div>
        <!--  -->
        <div class="main layout_main">
            <div class="top">
                <p class="title">© 版权信息（Copyright Notice）</p>
                <p class="time">最后更新日期：2025年7月24日</p>
            </div>
            <!--  -->
            <div class="content">
                <p>本网站由奢颜Ambassador+（以下简称“本公司”）运营，网站中展示的所有内容均受到中国及国际著作权法律的保护。</p>
            </div>
            <!--  -->
            <div class="content">
                <p class="h1">一、版权归属</p>
                <ol>
                    <li>
                        <div class="text">
                            <p>本网站内的所有内容，包括但不限于：</p>
                            <ul>
                                <li><p>艺人或艺术家的照片、视频、形象资料；</p></li>
                                <li><p>插画、图案、绘画、平面设计等艺术作品；</p></li>
                                <li><p>合作案例展示、设计方案、品牌包装；</p></li>
                                <li><p>网站页面结构、文字描述、图形图标、按钮样式等界面元素</p></li>
                            </ul>
                            <p>均为本公司或其签约艺人/艺术家/合作方所独立创作，<b>版权归属其原创作者或拥有合法授权的相关方所有</b>。</p>
                        </div>
                    </li>
                    <li>
                        <div class="text">
                            <p>未经许可，任何单位或个人<b>不得复制、转载、编辑、修改、传播、展示、出售或以任何形式使用上述内容</b>，包括但不限于商业宣传、产品包装、网络推广或社交媒体内容。</p>
                        </div>
                    </li>
                    <li>
                        <div class="text">
                            <p>对于已签署正式授权协议的合作方，必须在授权范围、时间、用途与渠道内使用相关作品。超范围使用亦属侵权。</p>
                        </div>
                    </li>
                </ol>
            </div>
            <!--  -->
            <div class="content">
                <p class="h1">二、禁止行为与法律责任</p>
                <p>以下行为被明确禁止，且本公司保留追究法律责任的权利：</p>
                <ul>
                    <li><p>擅自使用、复制、截取或再发布本网站所展示的艺人肖像、艺术作品或设计内容；</p></li>
                    <li><p>将未经授权的艺术作品用于产品包装、广告、推广、展览、印刷等商业用途；</p></li>
                    <li><p>删除或篡改作品中的签名、水印或版权信息标识；</p></li>
                    <li><p>冒用奢颜名义进行虚假推广、盗图仿品等行为。</p></li>
                </ul>
                <p>如发生上述行为，本公司将采取包括但不限于发函警告、要求下架、终止合作、法律诉讼等手段维护权益，并依法索赔。</p>
            </div>
            <!--  -->
            <div class="content">
                <p class="h1">三、合法使用与授权方式</p>
                <p>我们欢迎以下方式的合法合作：</p>
                <ul>
                    <li><p>品牌联名、产品包装与宣传图案授权</p></li>
                    <li><p>跨界合作、展览呈现、衍生品开发</p></li>
                    <li><p>艺术家定制设计、艺人品牌代言合作</p></li>
                </ul>
                <p>如您对某位艺人/艺术家的作品或形象感兴趣，并希望合作或授权使用，请联系：</p>
                <p class="flex align_center"><img class="icon" src="@/assets/images/icon_terms_email.png"/><b>授权和商务邮箱：</b><a href="mailto:tinagao@supermediachina.com">tinagao@supermediachina.com</a></p>
                <p class="flex align_center"><img class="icon" src="@/assets/images/icon_terms_tel.png"/><b>授权商务电话：</b><a href="tel:8621-62148217">8621-62148217</a>，<a href="tel:13701998955">13701998955</a></p>
                <p>我们将根据实际项目内容评估是否授权，并提供正式授权协议文件。<b>未经授权不得使用。</b></p>
            </div>
            <!--  -->
            <div class="content">
                <p class="h1">四、其他说明</p>
                <ol>
                    <li><p>本版权声明适用于奢颜主域名下的所有页面及内容（如：<a href="//www.ambassadorplus.com">www.ambassadorplus.com</a> , <a href="//www.ambassadorplus-ip.com" target="_blank">www.ambassadorplus-ip.com</a>）。	</p></li>
                    <li><p>奢颜保留随时修改和更新本声明内容的权利，修改后的内容一经发布即生效。</p></li>
                    <li><p>若您发现本站内容被他人盗用，欢迎向我们举报，共同维护原创作者的权益。</p></li>
                </ol>
            </div>
            <!--  -->
            <div class="bottom flex justify_between align_center">
                <div class="l">
                    <p class="p1">© 2025 奢颜 Ambassador<sup>+</sup> 版权所有</p>
                    <p class="p2">保留所有权利 | All Rights Reserved</p>
                </div>
                <div class="btn layout_flex_center" v-if="history > 2" @click="$router.go(-1)">返回</div>
                <router-link class="btn layout_flex_center" v-else to="/">返回</router-link>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.main{
    padding: .6rem 0;
    font-size: .2rem;
    line-height: 1.8;
    .bottom{
        .p1{
            font-size: .2rem;
        }
        .p2{
            font-size: .16rem;
        }
        .btn{
            line-height: 1;
            height: .42rem;
            border: 1px solid #000;
            padding: 0 .14rem;
            cursor: pointer;
        }
    }
    .content{
        border-bottom: 2px solid #c9c9c9;
        padding-bottom: .3rem;
        margin-bottom: .3rem;
    }
    .top{
        margin-bottom: .6rem;
    }
    .icon{
        width: .31rem;
        margin-right: .1rem;
    }
    p{
        margin-bottom: .3em;
    }
    b{
        color: #000;
    }
    ul{
        list-style: disc;
        padding-left: .3rem;
    }
    ol{
        list-style: auto;
        padding-left: .3rem;
    }
    .title,
    .time{
        text-align: center;
    }
    .title{
        font-size: .32rem;
        font-weight: bold;
        margin-bottom: .1rem;
    }
    .time{
        font-size: .22rem;
    }
    .h1{
        font-size: .22rem;
    }
}
.banner{
    height: 5.36rem;
    position: relative;
    .bg{
        position: absolute;
        z-index: -1;
        color: #fff;
    }
    .name{
        font-size: .36rem;
        font-weight: bold;
        color: #fff;
        margin-top: 1rem;
    }
}
</style>